import axios from 'axios'



export function fetchCustomerLanes(args) {
    const params = (args) ? {...args} : {}
    const customer_id = params.customer_id ?? '~'

    return axios({
        method: 'get',
        url: `/api/customers/${customer_id}/sourcing_lanes`,
        params
    })
}

export function fetchCustomerLaneLoads(args) {
    const {customer_lane_id} = args
    return axios({
        method: 'get',
        url: `/api/customers/~/sourcing_lanes/${customer_lane_id}/loads`
    })
}

export function fetchLaneLoadStats(args) {
    const {customer_lane_id} = args
    return axios({
        method: 'get',
        url: `/api/customers/~/sourcing_lanes/${customer_lane_id}/load_stats`
    })
}

export function fetchLaneOffers(args) {
    const {sourcing_lane_id} = args
    return axios({
        method: 'get',
        url: `/api/sourcing_lanes/${sourcing_lane_id}/offers`
    })
}

export function addLaneOffer(sourcing_lane_id, data) {
    return axios({
        method: 'post',
        url: `/api/sourcing_lanes/${sourcing_lane_id}/offers`,
        data
    })
}

export function deleteLaneOffer(offer_id) {
    return axios({
        method: 'delete',
        url: `/api/sourcing_lanes/~/offers/${offer_id}`
    })
}
